import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import { convertEpochToDate } from "../../../utils";
import { useHistory } from "react-router-dom";
import { Loader } from "@egovernments/digit-ui-react-components";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    borderCollapse: "collapse",
  },

  // Header Styling
  headerRow: {
    backgroundColor: "rgb(21 124 179)",
  },
  headerCell: {
    color: "white !important",
    fontWeight: "bold",
    fontSize: "14px",
  },

  // Zebra Stripe Rows
  tableRowOdd: {
    backgroundColor: "#f7f7f7",   // light grey
  },
  tableRowEven: {
    backgroundColor: "#ffffff",   // white
  },

  // Hover Effect
  tableRowHover: {
    "&:hover": {
      backgroundColor: "#e6f4ff",   // subtle light blue
      cursor: "pointer",
      transition: "0.2s ease-in-out",
    },
  },

  // Cell Border Adjustment
  tableCell: {
    borderBottom: "1px solid #ddd",
    padding: "12px 16px",
    fontSize: "12px",
  },
});



const InboxTable = ({ apiData, type }) => {
  const classes = useStyles();
  const history = useHistory();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // 10 rows per page

  const handleSubmit = () => {
    history.push("/");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const licenses = apiData?.Licenses || [];

  // Slice data for the page
  const paginatedData = licenses?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  if (licenses.length === 0) {
    return <Loader />
  }
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table}>
        <TableHead className={classes.headerRow}>
          <TableRow>
            <TableCell className={classes.headerCell}>Sl.#</TableCell>
            <TableCell className={classes.headerCell}>LTP Name</TableCell>
            <TableCell className={classes.headerCell}>LTP Type</TableCell>
            <TableCell className={classes.headerCell}>Application Number</TableCell>
            <TableCell className={classes.headerCell}>License Number</TableCell>
            <TableCell className={classes.headerCell}>Mobile No</TableCell>
            <TableCell className={classes.headerCell}>Email</TableCell>
            <TableCell className={classes.headerCell}>District</TableCell>
            <TableCell className={classes.headerCell}>Validity</TableCell>
            {/* <TableCell className={classes.headerCell}>Status</TableCell> */}
          </TableRow>
        </TableHead>


        <TableBody>
          {paginatedData.map((item, index) => (
            <TableRow
              key={index}
              className={`${index % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd} ${classes.tableRowHover}`}
            >
              <TableCell>{page * rowsPerPage + index + 1}</TableCell>
              <TableCell>{item?.tradeLicenseDetail?.owners?.[0]?.name}</TableCell>
              <TableCell>{item?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split(".")?.[0]}</TableCell>
              <TableCell>{item?.applicationNumber}</TableCell>
              <TableCell>{item?.tradeLicenseDetail?.owners?.[0]?.architectureNo}</TableCell>
              <TableCell>{item?.tradeLicenseDetail?.owners?.[0]?.mobileNumber}</TableCell>
              <TableCell>{item?.tradeLicenseDetail?.owners?.[0]?.emailId}</TableCell>
              <TableCell>{item?.tradeLicenseDetail?.owners?.[0]?.correspondenceAddress?.district}</TableCell>
              <TableCell>{convertEpochToDate(item?.validupto)}</TableCell>
              {/* <TableCell>{item?.status}</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Pagination Component */}
      <TablePagination
        component="div"
        count={licenses.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[10, 20, 50, 100]}
      />
    </TableContainer>
  );
};

export default InboxTable;
